import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    name: "",
    // hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", affix: true },
        component: () => import("@/views/dashboard/index")
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index")
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  }
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "User",
    meta: { title: "用户管理", permissions: ["admin", "user"], icon: "users" },
    children: [
      {
        path: "/user/list",
        name: "Users",
        component: () => import("@/views/user/index"),
        meta: { title: "用户列表", permissions: ["admin","user"] }
      },
      {
        path: "/user/whitelist",
        name: "whitelist",
        component: () => import("@/views/user/whitelist"),
        meta: { title: "白名单列表", permissions: ["admin", "user"] }
      },
      {
        path: "/wallet/walletList",
        name: "walletList",
        component: () => import("@/views/wallet/index"),
        meta: { title: "用户钱包列表", permissions: ["admin", "user"] }
      },
      {
        path: "/user/invitationRanking",
        name: "invitationRanking",
        component: () => import("@/views/user/invitationRanking"),
        meta: { title: "拉新排行榜", permissions: ["admin","user"] }
      },
      {
        path: "/user/energyRanking",
        name: "energyRanking",
        component: () => import("@/views/user/energyRanking"),
        meta: { title: "猩能源排行榜", permissions: ["admin","user"] }
      },
      {
        path: "/user/team",
        name: "Teams",
        component: () => import("@/views/user/team"),
        meta: { title: "团队列表", permissions: ["team"] }
      },
      {
        path: "/user/dpWallet",
        name: "DpWallet",
        component: () => import("@/views/user/dpWallet"),
        meta: { title: "DP钱包", permissions: ["dpWallet"] }
      },
      {
        path: "/user/dpWalletRecord",
        name: "DpWalletRecord",
        hidden: true,
        component: () => import("@/views/user/dpWalletRecord"),
        meta: { title: "DP钱包明细", permissions: ["dpWallet"] }
      },
      {
        path: "/user/otcWallet",
        name: "OtcWallet",
        component: () => import("@/views/user/otcWallet"),
        meta: { title: "OTC钱包", permissions: ["otcWallet"] }
      },
      {
        path: "/user/otcWalletRecord",
        name: "OtcWalletRecord",
        hidden: true,
        component: () => import("@/views/user/otcWalletRecord"),
        meta: { title: "OTC钱包明细", permissions: ["otcWallet"] }
      },
      {
        path: "/user/charge",
        name: "Charge",
        component: () => import("@/views/user/charge"),
        meta: { title: "充值回收", permissions: ["charge"] }
      },
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "product",
    meta: { title: "NFT管理", permissions: ["admin", "product_type", "product_list",'product'], icon: "tree" },
    children: [
      {
        path: "/product/issuer",
        name: "issuer",
        component: () => import("@/views/product/issuer"),
        meta: { title: "发行方列表", permissions: ["admin", "product_issuer",'product'] },
      },
      {
        path: "/product/category",
        name: "category",
        component: () => import("@/views/product/category"),
        meta: { title: "专区列表", permissions: ["admin", "product_issuer",'product'] },
      },
      {
        path: "/product/artMuseum",
        name: "artMuseum",
        component: () => import("@/views/product/artMuseum"),
        meta: { title: "艺术馆列表", permissions: ["admin", "product_issuer",'product'] },
      },
      {
        path: "/product/list",
        name: "list",
        component: () => import("@/views/product/list"),
        meta: { title: "NFT列表", permissions: ["admin", "product_list",'product'] },
      },
      {
        path: "/product/list_edit",
        name: "list_edit",
        hidden: true,
        component: () => import("@/views/product/list_edit"),
        meta: { title: "NFT编辑", permissions: ["admin", "product_list",'product'] },
      },
      {
        path: "/product/reservedApplyList",
        name: "reservedApplyList",
        hidden: true,
        component: () => import("@/views/product/reservedApplyList"),
        meta: { title: "预售申请列表", permissions: ["admin", "product_list",'product'] },
      },
      {
        path: "/product/nftList",
        name: "nftList",
        hidden: false,
        component: () => import("@/views/product/nftList"),
        meta: { title: "NFT收藏者", permissions: ["admin", "product_list",'product'] },
      },
      {
        path: "/product/airdropLog",
        name: "airdropLog",
        hidden: false,
        component: () => import("@/views/product/airdropLog"),
        meta: { title: "空投记录", permissions: ["admin", "product_list",'product'] },
      },
      {
        path: "/product/passOnLog",
        name: "passOnLog",
        hidden: false,
        component: () => import("@/views/product/passOnLog"),
        meta: { title: "转赠记录", permissions: ["admin", "product_list",'product'] },
      },
      {
        path: "/product/snap_list",
        name: "snap_list",
        hidden: false,
        component: () => import("@/views/product/snap_list"),
        meta: { title: "快照记录", permissions: ["admin", "product_list",'product'] },
      },
      // {
      //   path: "/product/participation_pt",
      //   name: "participation_pt",
      //   hidden: true,
      //   component: () => import("@/views/product/participation_pt"),
      //   meta: { title: "拼团管理", permissions: ["admin", "product_list"] },
      // },
      // {
      //   path: "/product/participation_kj",
      //   name: "participation_kj",
      //   hidden: true,
      //   component: () => import("@/views/product/participation_kj"),
      //   meta: { title: "砍价管理", permissions: ["admin", "product_list"] },
      // },
    ],
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Order",
    meta: { title: "订单管理", permissions: ["order","admin"], icon: "system" },
    children: [
      {
        path: "/order/list",
        name: "OrderList",
        component: () => import("@/views/order/index"),
        meta: { title: "订单列表", permissions: ["order","admin"] }
      },
      {
        path: "/consignment/index",
        name: "ConsignmentList",
        component: () => import("@/views/consignment/index"),
        meta: { title: "寄售列表", permissions: ["order","admin"] }
      },
      {
        path: "/consignment/list",
        name: "ConsignmentOrderList",
        component: () => import("@/views/consignment/order"),
        meta: { title: "寄售订单列表", permissions: ["order","admin"] }
      },
      {
        path: "/consignment/rechargeList",
        name: "RechargeList",
        component: () => import("@/views/wallet/order"),
        meta: { title: "充值订单列表", permissions: ["order","admin"] }
      },
      
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "finance",
    meta: { title: "财务管理", permissions: ["admin", "finance_log"], icon: "example" },
    children: [
      {
        path: "/finance/userAccountLog",
        name: "userAccountLog",
        component: () => import("@/views/finance/userAccountLog"),
        meta: { title: "财务流水", permissions: ["admin", "finance_log"] },
      },
      {
        path: "/wallet/log",
        name: "walletLog",
        component: () => import("@/views/wallet/log"),
        meta: { title: "钱包流水", permissions: ["admin", "finance_log"] },
      },
      {
        path: "/wallet/cashOutList",
        name: "cashOutList",
        component: () => import("@/views/wallet/cashout"),
        meta: { title: "钱包提现", permissions: ["admin", "finance_log"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "website",
    meta: { title: "建站管理", permissions: ["admin", "banner_index", "park_detail", "banner_ticket", "project_admin", "activity", "about_us", "feedback", "reason", "system","user_use_agreement","website"], icon: "system" },
    children: [
      {
        path: "/website/banner_index",
        name: "banner_index",
        component: () => import("@/views/website/banner_index"),
        meta: { title: "首页轮播图", permissions: ["admin", "banner_index","website"] },
      },
      // {
      //   path: "/website/VIP_set",
      //   name: "VIP_set",
      //   component: () => import("@/views/website/VIP_set"),
      //   meta: { title: "会员设置", permissions: ["admin", "banner_ticket"] },
      // },
      // {
      //   path: "/website/relation",
      //   name: "relation",
      //   component: () => import("@/views/website/relation"),
      //   meta: { title: "联系我们", permissions: ["admin", "system"] },
      // },
      {
        path: "/website/about_us",
        name: "about_us",
        component: () => import("@/views/website/about_us"),
        meta: { title: "关于我们", permissions: ["admin", "about_us","website"] },
      },
      {
        path: "/website/user_agreement",
        name: "user_agreement",
        component: () => import("@/views/website/about_us"),
        meta: { title: "用户协议", permissions: ["admin", "user_agreement","website"] },
      },
      {
        path: "/website/privacy_agreement",
        name: "privacy_agreement",
        component: () => import("@/views/website/about_us"),
        meta: { title: "隐私政策", permissions: ["admin", "privacy_agreement","website"] },
      },
      {
        path: "/website/cash_out_rule",
        name: "cash_out_rule",
        component: () => import("@/views/website/about_us"),
        meta: { title: "提现规则", permissions: ["admin", "cash_out_rule", "website"] },
      },
      {
        path: '/operate/feedback',
        name: 'feedback',
        component: () => import('@/views/operate/feedback'),
        meta: { title: '意见反馈', permissions: ["admin", "website"] }
      },
      {
        path: '/operate/feedbackDetailedInfo',
        name: 'FeedbackDetailedInfo',
        hidden: true,
        component: () => import('@/views/operate/feedbackDetailedInfo'),
        meta: { title: '查看详情' , permissions: ["admin", "website"]}
      },
      {
        path: "/website/informationAdmin",
        name: "informationAdmin",
        component: () => import("@/views/website/informationAdmin"),
        meta: { title: "资讯管理", permissions: ["admin", "informationAdmin","website"] },
      },
      {
        path: "/website/informationAdminEdit",
        name: "informationAdminEdit",
        hidden: true,
        component: () => import("@/views/website/informationAdminEdit"),
        meta: { title: "资讯新增修改", permissions: ["admin", "invoiceList","website"] },
      },
      {
        path: "/website/systemNotify",
        name: "systemNotify",
        component: () => import("@/views/website/systemNotify"),
        meta: { title: "系统通知管理", permissions: ["admin", "systemNotify","website"] },
      },
      {
        path: "/website/systemNotifyEdit",
        name: "systemNotifyEdit",
        hidden: true,
        component: () => import("@/views/website/systemNotifyEdit"),
        meta: { title: "系统通知新增修改", permissions: ["admin", "invoiceList","website"] },
      },
      // {
      //   path: "/website/user_service_agreement",
      //   name: "user_service_agreement",
      //   component: () => import("@/views/website/about_us"),
      //   meta: { title: "用户服务协议", permissions: ["admin", "project_admin"] },
      // },
      // {
      //   path: "/website/user_privacy_agreement",
      //   name: "user_privacy_agreement",
      //   component: () => import("@/views/website/about_us"),
      //   meta: { title: "用户隐私协议", permissions: ["admin", "project_admin"] },
      // },
      // {
      //   path: "/website/leave_word",
      //   name: "leave_word",
      //   component: () => import("@/views/website/leave_word"),
      //   meta: { title: "用户留言", permissions: ["admin", "project_admin"] },
      // },
      // {
      //   path: "/website/LookChat",
      //   name: "LookChat",
      //   hidden: true,
      //   component: () => import("@/views/website/LookChat"),
      //   meta: { title: "查看留言", permissions: ["admin", "project_admin"] },
      // },

      // {
      //   path: "/website/setting",
      //   name: "setting",
      //   component: () => import("@/views/website/setting"),
      //   meta: { title: "系统设置" },
      // },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "System",
    meta: { title: "系统设置", permissions: ["admin","system"], icon: "system" },
    children: [
      {
        path: "/system/config",
        name: "Config",
        component: () => import("@/views/system/config"),
        meta: { title: "参数设置", permissions: ["admin","config","system"] }
      },
      // {
      //   path: "/roles",
      //   name: "Role",
      //   component: () => import("@/views/role/index"),
      //   meta: { title: "角色列表", permissions: ["role"] }
      // }
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Admin",
    meta: { title: "管理员设置", permissions: ["admin", "role"], icon: "system" },
    children: [
      {
        path: "/admin/list",
        name: "Admin",
        component: () => import("@/views/admin/index"),
        meta: { title: "管理员列表", permissions: ["admin"] }
      },
      // {
      //   path: "/roles",
      //   name: "Role",
      //   component: () => import("@/views/role/index"),
      //   meta: { title: "角色列表", permissions: ["role"] }
      // }
    ]
  },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Content",
  //   meta: {
  //     title: "内容管理",
  //     permissions: ["banner", "about"],
  //     icon: "content"
  //   },
  //   children: [
  //     {
  //       path: "/banner/list",
  //       name: "Banners",
  //       component: () => import("@/views/banner/index"),
  //       meta: { title: "轮播图设置", permissions: ["banner"] }
  //     },
  //     {
  //       path: "/about",
  //       name: "About",
  //       component: () => import("@/views/about/index"),
  //       meta: { title: "关于我们", permissions: ["about"] }
  //     }
  //   ]
  // },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Others",
  //   meta: { title: "其他", icon: "others" },
  //   children: [
  //     {
  //       path: "/map",
  //       name: "Map",
  //       component: () => import("@/views/others/map"),
  //       meta: { title: "地图" }
  //     }
  //   ]
  // },
  { path: "*", redirect: "/error/404", hidden: true }
];
